import type { AxiosResponse } from 'axios';
import type { MutationFunction } from 'react-query';
import { useMutation } from 'react-query';

import { useNotificationStore } from '@/common';
import { axios } from '@/library/axios';
import type { GetOtpArgsType, GetOtpResponse } from '@/types/auth';

export const getOtp: MutationFunction<
  AxiosResponse<GetOtpResponse>,
  GetOtpArgsType
> = (data: GetOtpArgsType) => {
  return axios.post('/notifications/otps?androidAppVersionCode=999', data);
};

export const useGetOtp = () => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Success',
        message: 'OTP Sent Successfully',
      });
    },
    onError: (data: any) => {
      addNotification({
        type: 'error',
        title: 'Error',
        message: data?.response?.data?.detail,
      });
    },
    mutationFn: getOtp,
    useErrorBoundary: false,
  });
};
